<template>
  <div>
    <van-row span="24">
      <van-col span="8" v-for="(movie, index) in movies" :key="movie.id + '_' + index" @click="showDetail(movie)" v-if="(isAcc && movie.name === keyword) || !isAcc">
        <VodInfo :info="movie" :is-proxy="true"></VodInfo>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { getVodResult } from '@/api/vod'
import { Base64 } from 'js-base64'
import VodInfo from '@/components/blocks/vod/VodInfo'

export default {
  name: 'VodResult',
  components: {
    VodInfo
  },
  data () {
    return {
      movies: [],
      keyword: '',
      isAcc: false
    }
  },
  methods: {
    search () {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }, 100)
      this.$parent.progressOn()
      if (window.localStorage.getItem('vod_keyword') === this.keyword) {
        this.movies = JSON.parse(window.localStorage.getItem('vod_result'))
        this.$parent.progressOff()
        return false
      }
      getVodResult({
        keyword: this.keyword
      }).then(res => {
        this.movies = res.result
        window.localStorage.setItem('vod_keyword', this.keyword)
        window.localStorage.setItem('vod_result', JSON.stringify(this.movies))
        this.$parent.progressOff()
      })
    },
    showDetail (movie) {
      location.href = '/#/in-app/vod/detail/' + movie.sourceKey + '/' + movie.id
    },
    change () {
      this.$parent.navLeftText = ''
      this.keyword = Base64.decode(this.$route.params.keyword.replaceAll('_', '/'))
      if (typeof this.$route.params.acc !== 'undefined') {
        this.isAcc = true
      }
      this.$parent.title = this.keyword
      this.search()
    }
  },
  mounted () {
    this.change()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/inApp/Vod/Result.vue